module.exports = __webpack_public_path__ + "static/media/communaute_decolorStop_mobile.a5bc70dd.jpg";